import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  current: any;
  previous: any;

  constructor() { }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  compareTokens(controlName: string, matchingTokens: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingTokens];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      if (control.value < matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  encode(str) {
    return btoa(str);
  }
  decode(str) {
    return atob(str);
  }
  transformToSnakeCase(data) {
    let newData;

    if (data instanceof File || data instanceof FormData) { // file object -> transformation is not needed
      newData = data;
    } else {
      if (data && _.isObject(data) && !Array.isArray(data)) { // object
        newData = {};
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const newKey = _.snakeCase(key);
            newData[newKey] = data[key];
            if (data[key] && _.isObject(data[key]) && !Array.isArray(data[key])) { // object
              newData[newKey] = this.transformToSnakeCase(data[key]);
            } else if (data[key] && Array.isArray(data[key])) { // array
              newData[newKey] = this.transformToSnakeCase(data[key]);
            }
          }
        }
      } else if (data && _.isObject(data) && Array.isArray(data)) { // array
        newData = [];
        for (const value of data) {
          if (_.isObject(value) || Array.isArray(value)) { // array or object
            newData.push(this.transformToSnakeCase(value));
          } else { // any value except array and object
            newData.push(value);
          }
        }
      }
    }

    return newData;
  }

  transformToCamelCase(data) {
    let newData;
    if (data && _.isObject(data) && !Array.isArray(data)) { // object
      newData = {};
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const newKey = _.camelCase(key);
          newData[newKey] = data[key];
          if (data[key] && _.isObject(data[key]) && !Array.isArray(data[key])) { // object
            newData[newKey] = this.transformToCamelCase(data[key]);
          } else if (data[key] && Array.isArray(data[key])) { // array
            newData[newKey] = this.transformToCamelCase(data[key]);
          }
        }
      }
    } else if (data && _.isObject(data) && Array.isArray(data)) { // array
      newData = [];
      for (const value of data) {
        if (_.isObject(value) || Array.isArray(value)) { // array or object
          newData.push(this.transformToCamelCase(value));
        } else { // any value except array and object
          newData.push(value);
        }
      }
    }

    return newData;
  }

  // Method change as per QA's date time chnages : Sunil

  timeSince(time, showTime?: Boolean) {
    this.current = new Date();
    this.previous = new Date(time);

    let currentDateStartTime = new Date().setHours(0, 0, 0);
    let currentTimestamp = this.current.getTime();

    // var msPerMinute = 60 * 1000;
    // var msPerHour = msPerMinute * 60;
    // var msPerDay = msPerHour * 24;
    var msPerDay = currentTimestamp - currentDateStartTime;
    var elapsed = this.current - this.previous;


    var amOrPm = (this.previous.getHours() < 12) ? "AM" : "PM";
    var hour = (this.previous.getHours() <= 12) ? this.previous.getHours() : this.previous.getHours() - 12;
    // currentHours = ("0" + currentHours).slice(-2);
    var shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    hour = (hour < 10) ? '0' + hour : hour;
    var minutes = (this.previous.getMinutes() < 10) ? '0' + this.previous.getMinutes() : this.previous.getMinutes();

    //

    if (elapsed < msPerDay) {
      return hour + ':' + minutes + ' ' + amOrPm;
    }
    else if (elapsed > msPerDay) {
      if (showTime == false)
        return this.previous.getDate() + ' ' + shortMonths[this.previous.getMonth()] + ' ' + this.previous.getFullYear();
      else
        return this.previous.getDate() + ' ' + shortMonths[this.previous.getMonth()] + ' ' + this.previous.getFullYear() + ' ' + hour + ':' + minutes + ' ' + amOrPm;
    }
  }
  // timeSince(time) {
  //   this.current = new Date();
  //   this.previous = new Date(time);
  //   var msPerMinute = 60 * 1000;
  //   var msPerHour = msPerMinute * 60;
  //   var msPerDay = msPerHour * 24;
  //   var msPerMonth = msPerDay * 30;
  //   var msPerYear = msPerDay * 365;

  //   var elapsed = this.current - this.previous;

  //   if (elapsed < msPerMinute) {
  //     return Math.round(elapsed / 1000) <= 1 ? Math.round(elapsed / 1000) + ' second ago' : Math.round(elapsed / 1000) + ' seconds ago';
  //   } else if (elapsed < msPerHour) {
  //     return Math.round(elapsed / msPerMinute) <= 1 ? Math.round(elapsed / msPerMinute) + ' minute ago' : Math.round(elapsed / msPerMinute) + ' minutes ago';
  //   } else if (elapsed < msPerDay) {
  //     return Math.round(elapsed / msPerHour) <= 1 ? Math.round(elapsed / msPerHour) + ' hour ago' : Math.round(elapsed / msPerHour) + ' hours ago';
  //   } else if (elapsed < msPerMonth) {
  //     return Math.round(elapsed / msPerDay) <= 1 ? '' + Math.round(elapsed / msPerDay) + ' day ago' : '' + Math.round(elapsed / msPerDay) + ' days ago';
  //   } else if (elapsed < msPerYear) {
  //     return Math.round(elapsed / msPerMonth) <= 1 ? '' + Math.round(elapsed / msPerMonth) + ' month ago' : '' + Math.round(elapsed / msPerMonth) + ' months ago';
  //   } else {
  //     return Math.round(elapsed / msPerYear) <= 1 ? '' + Math.round(elapsed / msPerYear) + ' year ago' : '' + Math.round(elapsed / msPerYear) + ' years ago';
  //   }
  // }

}